/** Get Dashboard Chart data */
export const API_SUCCESS = "API_SUCCESS";
export const API_FAIL = "API_FAIL";
export const GET_CHARTS_DATA = "GET_CHARTS_DATA";
//GET FINANCIAL AID STATS
export const GET_AID_REQUEST = "GET_AID_REQUEST"
export const GET_AID_SUCCESS = "GET_AID_SUCCESS"
export const GET_AID_FAIL = "GET_AID_FAIL"
//GET TOTAL LABS REGISTERED
export const GET_TOTALLABS_REQUEST = "GET_TOTALLABS_REQUEST"
export const GET_TOTALLABS_SUCCESS = "GET_TOTALLABS_SUCCESS"
export const GET_TOTALLABS_FAIL = "GET_TOTALLABS_FAIL"
//GET TOTAL Earnings
export const GET_TOTALEARNINGS_REQUEST = "GET_TOTALEARNINGS_REQUEST"
export const GET_TOTALEARNINGS_SUCCESS = "GET_TOTALEARNINGS_SUCCESS"
export const GET_TOTALEARNINGS_FAIL = "GET_TOTALEARNINGS_FAIL"
//GET TOTAL COMPLAINTS
export const GET_TOTALCOMPLAINTS_REQUEST = "GET_TOTALCOMPLAINTS_REQUEST"
export const GET_TOTALCOMPLAINTS_SUCCESS = "GET_TOTALCOMPLAINTS_SUCCESS"
export const GET_TOTALCOMPLAINTS_FAIL = "GET_TOTALCOMPLAINTS_FAIL"
//GET TOTAL Financial aid
export const GET_TOTALFA_REQUEST = "GET_TOTALFA_REQUEST"
export const GET_TOTALFA_SUCCESS = "GET_TOTALFA_SUCCESS"
export const GET_TOTALFA_FAIL = "GET_TOTALFA_FAIL"
//GET USER STATS
export const GET_USERSTATS_REQUEST = "GET_USERSTATS_REQUEST"
export const GET_USERSTATS_SUCCESS = "GET_USERSTATS_SUCCESS"
export const GET_USERSTATS_FAIL = "GET_USERSTATS_FAIL"
